import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { ImageEnum } from '../../utils/image.enum';
import { Router } from '@angular/router';
import { StorageService } from '../../../core/services/storage.service';
import { PrimaryButtonComponent } from '../primary-button/primary-button';
import { OutlineButtonComponent } from '../outline-button/outline-button';
import { AuthService } from '../../../features/auth/services/auth.service';
import { UserProfileData } from '../../../features/auth/model/auth.model';
import { HeaderStateService } from '../../services/header-state.service';

@Component({
  selector: 'app-header',
  imports: [PrimaryButtonComponent,OutlineButtonComponent],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements OnInit {
  @Input() userName = 'Sharma';
  @Input() userRole = 'Admin';
  @Input() subtitle = "Let's continue your NEET PG preparation.";
  @Input() showMenuButton = true;

  @Output() menuClick = new EventEmitter<void>();

  protected readonly imageEnum = ImageEnum;
  protected readonly greeting = 'Hey';
  protected isLogoutModalOpen = false;
  protected isProfileDropdownOpen = false;
  protected displayName = this.userName;
  protected readonly userProfile = signal<UserProfileData | null>(null);

  private readonly router = inject(Router);
  private readonly storageService = inject(StorageService);
  private readonly authService = inject(AuthService);
  public readonly headerState: HeaderStateService = inject(HeaderStateService);

  ngOnInit(): void {
    const storedUser = this.storageService.getItem<{ full_name?: string; fullName?: string; name?: string }>('userData');
    const storedName = storedUser?.full_name ?? storedUser?.fullName ?? storedUser?.name ?? this.userName;
    this.displayName = this.normalizeUserName(storedName);

    this.authService.getUserDetails().subscribe({
      next: (res) => {
        if (res?.data) {
          this.userProfile.set(res.data);
          this.displayName = this.normalizeUserName(res.data.name);
        }
      },
      error: () => {
        // Fallback or handle error if needed
      }
    });
  }

  protected onMenuClick(): void {
    this.menuClick.emit();
  }

  protected toggleProfileDropdown(event: Event): void {
    event.stopPropagation();
    this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
  }

  protected closeProfileDropdown(): void {
    this.isProfileDropdownOpen = false;
  }

  protected openLogoutModal(event: Event): void {
    event.stopPropagation();
    this.isLogoutModalOpen = true;
    this.isProfileDropdownOpen = false;
  }

  protected closeLogoutModal(): void {
    this.isLogoutModalOpen = false;
  }

  protected confirmLogOut(): void {
    this.isLogoutModalOpen = false;
    this.storageService.clear();
    void this.router.navigate(['/login'], { replaceUrl: true });
  }

  private normalizeUserName(name: string): string {
    return name.replace(/^dr\.?\s*/i, '').trim() || this.userName;
  }
}
